// Match each word across the displayed identity, independently of accents/case.
export function normaliserRecherche(value) {
    return String(value == null ? '' : value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('fr').trim()
}

export function correspondRecherche(values, query) {
    const texte = values.map(normaliserRecherche).join(' ')
    return normaliserRecherche(query).split(/\s+/).filter(Boolean).every(mot => texte.includes(mot))
}
